// src/api/apiTransportations.js
import axios from "../utils/axios";

/// Get Transportations
export const getAllTransportations = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("transportations", { params });
    return data;
};

/// Get Transportation
export const getTransportation = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`transportations/${id}`);
    return data;
};

/// Get Transportations for Select
export const getTransportationsForSelect = async () => {
    const { data } = await axios.get("transportations/for-select");
    return data;
};

/// Create Transportation
export const createTransportation = async (req) => {
    try {
        const formData = new FormData();

        // Append name fields
        if (req.name?.ar) formData.append('name[ar]', req.name.ar);
        if (req.name?.en) formData.append('name[en]', req.name.en);

        // Append other fields
        formData.append('capacity', req.capacity);
        formData.append('status', req.status);

        // Append image if exists
        if (req.image) {
            formData.append('image', req.image);
        }

        const { data } = await axios.post("transportations", formData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            },
        });
        return data;
    } catch (error) {
        console.error("createTransportation error:", error);
        throw error;
    }
};

/// Update Transportation
export const updateTransportation = async (req, id) => {
    try {
        const formData = new FormData();

        // Method spoofing for PUT
        formData.append('_method', 'PUT');

        // Append name fields
        if (req.name?.ar) formData.append('name[ar]', req.name.ar);
        if (req.name?.en) formData.append('name[en]', req.name.en);

        // Append other fields
        formData.append('capacity', req.capacity);
        formData.append('status', req.status);
        if (req.image !== undefined && req.image !== null && req.image !== "") {
            formData.append("image", req.image);
        }

        const { data } = await axios.post(`transportations/${id}`, formData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            },
        });
        return data;
    } catch (error) {
        console.error("updateTransportation error:", error);
        throw error;
    }
};

/// Delete Transportation
export const deleteTransportation = async (id) => {
    try {
        const { data } = await axios.delete(`transportations/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteTransportation error:", error);
        throw error;
    }
};

/// Delete All Transportations
export const deleteAllTransportations = async (req = []) => {
    try {
        const { data } = await axios.delete(
            "transportations/mass-destroy",
            { data: req },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllTransportations error:", error);
        throw error;
    }
};

/// Restore Transportation
export const restoreTransportation = async (id) => {
    try {
        const { data } = await axios.post(`transportations/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreTransportation error:", error);
        throw error;
    }
};

/// Restore multiple Transportations
export const restoreAllTransportations = async (req = []) => {
    try {
        const { data } = await axios.post(
            "transportations/mass-restore",
            { ...req },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllTransportations error:", error);
        throw error;
    }
};

/// Force Delete Transportation
export const forceDeleteTransportation = async (id) => {
    try {
        const { data } = await axios.delete(`transportations/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteTransportation error:", error);
        throw error;
    }
};

/// Force Delete multiple Transportations
export const forceDeleteAllTransportations = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "transportations/mass-force-delete",
            { data: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllTransportations error:", error);
        throw error;
    }
};
